import { render, staticRenderFns } from "./ImprestAccounting.vue?vue&type=template&id=ef3f5c28&scoped=true"
import script from "./ImprestAccounting.vue?vue&type=script&lang=js"
export * from "./ImprestAccounting.vue?vue&type=script&lang=js"
import style0 from "./ImprestAccounting.vue?vue&type=style&index=0&id=ef3f5c28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef3f5c28",
  null
  
)

export default component.exports